import { ref, watch } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useMeta() {
  const page = usePage()
  const metaState = ref({
    // Existing meta fields
    title: '',
    description: '',
    keywords: '',
    ogImage: '',
    canonical_link: '',
    author: '',
    publishedAt: '',
    modifiedAt: '',
    // OpenGraph specific fields
    og_title: '',
    og_description: '',
    og_type: 'website',
    og_url: '',
    og_locale: 'en_US',
    og_site_name: '',
    // Twitter/X specific fields
    twitter_card: 'summary_large_image',
    twitter_site: '',
    twitter_creator: '',
    // BlueSky specific fields
    at_handle: '',
    at_displayName: '',
    at_description: '',
    at_image: '',
    at_image_alt: '',
    at_theme_color: '#0086FF',
  })

  watch(
    () => page.props.meta,
    (newMeta) => {
      if (newMeta) {
        metaState.value = { ...newMeta }
      }
    },
    { immediate: true, deep: true },
  )

  const setMeta = ({
    // Existing parameters
    title = '',
    description = '',
    keywords = '',
    ogImage = '',
    canonical_link = '',
    author = '',
    publishedAt = '',
    modifiedAt = '',
    // OpenGraph specific fields
    og_title = '',
    og_description = '',
    og_type = 'website',
    og_url = '',
    og_locale = 'en_US',
    og_site_name = '',
    // Twitter/X specific fields
    twitter_card = 'summary_large_image',
    twitter_site = '',
    twitter_creator = '',
    // BlueSky parameters
    at_handle = '',
    at_displayName = '',
    at_description = '',
    at_image = '',
    at_image_alt = '',
    at_theme_color = '#0086FF',
  } = {}) => {
    metaState.value = {
      title,
      description,
      keywords,
      ogImage,
      canonical_link,
      author,
      publishedAt,
      modifiedAt,
      // OpenGraph fields
      og_title: og_title || title,
      og_description: og_description || description,
      og_type,
      og_url,
      og_locale,
      og_site_name,
      // Twitter/X fields
      twitter_card,
      twitter_site,
      twitter_creator,
      // BlueSky fields
      at_handle,
      at_displayName: at_displayName || title,
      at_description: at_description || description,
      at_image: at_image || ogImage,
      at_image_alt: at_image_alt || title,
      at_theme_color,
    }
    page.props.meta = { ...metaState.value }
  }

  return {
    setMeta,
    metaState,
  }
}
